import { render, staticRenderFns } from "./TempRenewalPayment.vue?vue&type=template&id=64219fad&scoped=true"
import script from "./TempRenewalPayment.vue?vue&type=script&lang=js"
export * from "./TempRenewalPayment.vue?vue&type=script&lang=js"
import style0 from "./TempRenewalPayment.vue?vue&type=style&index=0&id=64219fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64219fad",
  null
  
)

export default component.exports